module.exports = __webpack_public_path__ + "static/img/mp3_bg.acbdde4b.png";